
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"components"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerWalkable"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"assetsComponent"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"componentPlugin"},"directives":[]}]}}]}}],"loc":{"start":0,"end":190}};
    doc.loc.source = {"body":"#import './componentPlugin.gql'\n#import \"./assetsComponent.gql\"\n\nfragment components on LearnerWalkable {\n  components {\n  \tid\n  \tconfig\n    ...assetsComponent\n    ...componentPlugin\n  }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./componentPlugin.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require("./assetsComponent.gql").definitions));


      module.exports = doc;
    
